import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

export default function Header({ christmasTheme }) {
  const location = useLocation();
  const pathname = location.pathname;
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  const active = pathname.startsWith("/quem-somos")
    ? "quem-somos"
    : pathname.startsWith("/estruturas")
    ? "estruturas"
    : pathname.startsWith("/aquecedor-solar")
    ? "aquecedor"
    : pathname.startsWith("/energia-solar")
    ? "energia"
    : pathname.startsWith("/contato")
    ? "contato"
    : "inicio";

  return (
    <header className={`header${christmasTheme ? " christmas" : ""}`}>
      <nav className="nav" aria-label="Principal">
        <div className="nav-container">
          <div className="nav-logo">
            <Link
              to="/"
              style={{
                textDecoration: "none",
                color: "inherit",
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              <img
                src="/logo inova.png"
                alt="Inova"
                style={{ height: "70px", maxHeight: "80px", width: "auto" }}
              />
            </Link>
          </div>
          <button
            type="button"
            className={`nav-toggle${menuOpen ? " active" : ""}`}
            aria-label={menuOpen ? "Fechar menu" : "Abrir menu"}
            aria-expanded={menuOpen}
            aria-controls="nav-menu"
            onClick={() => setMenuOpen((v) => !v)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <ul id="nav-menu" className={`nav-menu${menuOpen ? " active" : ""}`}>
            <li>
              <Link
                to="/"
                className={`nav-link${active === "inicio" ? " active" : ""}`}
                aria-current={active === "inicio" ? "page" : undefined}
              >
                Início
              </Link>
            </li>
            <li>
              <Link
                to="/estruturas"
                className={`nav-link${
                  active === "estruturas" ? " active" : ""
                }`}
                aria-current={active === "estruturas" ? "page" : undefined}
              >
                Estruturas
              </Link>
            </li>
            <li>
              <Link
                to="/aquecedor-solar"
                className={`nav-link${active === "aquecedor" ? " active" : ""}`}
                aria-current={active === "aquecedor" ? "page" : undefined}
              >
                Aquecedor Solar
              </Link>
            </li>
            <li>
              <Link
                to="/energia-solar"
                className={`nav-link${active === "energia" ? " active" : ""}`}
                aria-current={active === "energia" ? "page" : undefined}
              >
                Energia Solar
              </Link>
            </li>
            <li>
              <Link
                to="/quem-somos"
                className={`nav-link${
                  active === "quem-somos" ? " active" : ""
                }`}
                aria-current={active === "quem-somos" ? "page" : undefined}
              >
                Quem Somos
              </Link>
            </li>
            <li>
              <Link
                to="/contato"
                className={`nav-link${active === "contato" ? " active" : ""}`}
                aria-current={active === "contato" ? "page" : undefined}
              >
                Contato
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
}
